import React from "react";
import { css } from "@emotion/react";
import { colors, fontSize } from "style";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { breakpoints } from "style";
import { humanizeString } from "utils";

/**
 * ProfileFieldDisplay
 *
 * @param {String}   messageId
 * @param {String}   valueKey
 * @param {Boolean}  shouldRender
 * @param {Object}   data
 */
const ProfileFieldDisplay = ({ messageId, valueKey, data, shouldRender }) => {
  if (!shouldRender || !data?.[valueKey]) return null;

  return (
    <p css={styles.container}>
      <FormattedMessage id={messageId} values={{ [valueKey]: humanizeString(data[valueKey]) }} />
    </p>
  );
};

const styles = {
  container: css`
    font-size: ${fontSize.small};
    line-height: 1;
    color: ${colors.grayAnatomyLight1};
    text-align: center;
    margin-top: 1rem;

    @media (max-width: ${breakpoints.mobile}) {
      margin-bottom: 2rem;
    }
  `,
};

ProfileFieldDisplay.propTypes = {
  data: PropTypes.object.isRequired,
  messageId: PropTypes.string.isRequired,
  valueKey: PropTypes.string.isRequired,
  shouldRender: PropTypes.bool.isRequired,
};

export default ProfileFieldDisplay;
